import { IBOInfoCard } from "./IBOInfoCard";

export default IBOInfoCard;
